import { Paper, Stack, Typography } from "@mui/material";

export default function AlertWithIcon(props) {
	return (
		<Paper className={props.className} elevation={0} sx={props.sx}>
			<Stack direction="row" alignContent={"center"} alignItems={props.alignItems || "center"} spacing={0}>
				<Stack>{props.icon}</Stack>
				<Stack>
					<Typography variant="caption" display="inline-block" sx={props.textStyle}>
						{props.text}
					</Typography>
				</Stack>
			</Stack>
		</Paper>
	);
}
